module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-input__component",
    class: _vm.computedClasses
  }, [_c('i', {
    class: _vm.ico,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "type": "email",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.valueCopy)
    },
    on: {
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": function($event) {
        _vm.handleFocus(false)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.valueCopy = $event.target.value
      }, function($event) {
        $event.preventDefault();
        _vm.handleModelInput($event)
      }]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'url') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "type": "url",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.valueCopy)
    },
    on: {
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": function($event) {
        _vm.handleFocus(false)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.valueCopy = $event.target.value
      }, _vm.handleModelInput]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "type": "number",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "max": _vm.max,
      "min": _vm.min,
      "step": _vm.step,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.valueCopy)
    },
    on: {
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": [function($event) {
        _vm.handleFocus(false)
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.valueCopy = $event.target.value
      }, _vm.handleModelInput]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "type": "password",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "max": _vm.max,
      "min": _vm.min,
      "step": _vm.step,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.valueCopy)
    },
    on: {
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": function($event) {
        _vm.handleFocus(false)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.valueCopy = $event.target.value
      }, _vm.handleModelInput]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'tel') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "type": "tel",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "max": _vm.max,
      "min": _vm.min,
      "step": _vm.step,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.valueCopy)
    },
    on: {
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": function($event) {
        _vm.handleFocus(false)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.valueCopy = $event.target.value
      }, _vm.handleModelInput]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'text') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "type": "text",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.valueCopy)
    },
    on: {
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": function($event) {
        _vm.handleFocus(false)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.valueCopy = $event.target.value
      }, _vm.handleModelInput]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'select') ? _c('select', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.inputMask),
      expression: "inputMask"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valueCopy),
      expression: "valueCopy"
    }],
    ref: "input",
    staticClass: "material-input",
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": _vm.autocomplete,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valueCopy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleModelInput],
      "focus": function($event) {
        _vm.handleFocus(true)
      },
      "blur": function($event) {
        _vm.handleFocus(false)
      }
    }
  }, [_vm._t("options")], 2) : _vm._e(), _vm._v(" "), (_vm.type === 'select' && _vm.selectArrow) ? _c('i', {
    staticClass: "fa fa-chevron-down select-down",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("ico-check"), _vm._v(" "), (!_vm.focus) ? _vm._t("ico-check-email") : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "material-input-bar"
  }), _vm._v(" "), _c('label', {
    staticClass: "material-label"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("help-message"), _vm._v(" "), (!_vm.focus) ? _vm._t("help-message-email") : _vm._e(), _vm._v(" "), (_vm.errorMessages) ? _c('div', {
    staticClass: "material-errors"
  }, _vm._l((_vm.computedErrors), function(error) {
    return _c('div', {
      staticClass: "material-error"
    }, [_vm._v("\n      " + _vm._s(error) + "\n    ")])
  })) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-182c7590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/MaterialInput.vue
// module id = 730
// module chunks = 1